const cookieI18n = {
  "fr": {
    "hero": {
      "title": "Cookies & préférences",
      "desc": "Nous utilisons des cookies pour garantir le bon fonctionnement du site, mesurer l’audience et améliorer votre expérience. Vous pouvez modifier vos choix à tout moment.",
      "badges": {
        "essential": "Essentiels",
        "analytics": "Analytics",
        "performance": "Performance",
        "marketing": "Marketing"
      }
    },
    "summary": {
      "hint": "Gérez vos consentements par catégorie. Les cookies  essentiels  sont toujours actifs.",
      "reject": "Tout refuser (sauf essentiels)",
      "accept": "Tout accepter"
    },
    "categories": {
      "essential": {
        "label": "Essentiels (obligatoires)",
        "desc": "Nécessaires au fonctionnement du site (sécurité, session, panier...). Vous ne pouvez pas les désactiver."
      },
      "analytics": {
        "label": "Mesure d’audience (Google Analytics)",
        "desc": "Nous aident à comprendre l’utilisation du site (pages vues, parcours). Données agrégées et anonymisées."
      },
      "performance": {
        "label": "Performance",
        "desc": "Améliore le confort de navigation (mise en cache, tests A/B, optimisation des temps de chargement)."
      },
      "marketing": {
        "label": "Marketing",
        "desc": "Personnalisation des contenus/annonces et suivi des campagnes. Peut provenir de partenaires."
      }
    },
    "state": {
      "on": "Activé",
      "off": "Désactivé"
    },
    "analytics": {
      "note": "Outil utilisé : Google Analytics 4. Adresse IP anonymisée, données agrégées. ID de mesure :",
      "notConfigured": "non configuré"
    },
    "cta": {
      "rejectNonEssential": "Refuser les non essentiels",
      "save": "Enregistrer mes préférences"
    },
    "savedAt": "Dernière mise à jour :",
    "more": {
      "title": "En savoir plus",
      "text": "Pour plus d’informations sur l’usage des cookies et vos droits, consultez notre",
      "link": "politique de confidentialité"
    },
    "toast": {
      "allAccepted": "Tous les cookies ont été acceptés.",
      "onlyEssential": "Seuls les cookies essentiels sont conservés.",
      "saved": "Vos préférences ont été enregistrées."
    }
  },
  "en": {
    "hero": {
      "title": "Cookies & preferences",
      "desc": "We use cookies to ensure the site works properly, measure traffic, and improve your experience. You can change your choices at any time.",
      "badges": {
        "essential": "Essential",
        "analytics": "Analytics",
        "performance": "Performance",
        "marketing": "Marketing"
      }
    },
    "summary": {
      "hint": "Manage your consent by category. Essential cookies are always active.",
      "reject": "Reject all (except essential)",
      "accept": "Accept all"
    },
    "categories": {
      "essential": {
        "label": "Essential (required)",
        "desc": "Required for site operation (security, session, cart...). You cannot disable them."
      },
      "analytics": {
        "label": "Audience measurement (Google Analytics)",
        "desc": "Helps us understand site usage (page views, journeys). Aggregated and anonymized data."
      },
      "performance": {
        "label": "Performance",
        "desc": "Improves browsing comfort (caching, A/B tests, load-time optimizations)."
      },
      "marketing": {
        "label": "Marketing",
        "desc": "Personalized content/ads and campaign tracking. May come from partners."
      }
    },
    "state": {
      "on": "On",
      "off": "Off"
    },
    "analytics": {
      "note": "Tool used: Google Analytics 4. IP anonymized, aggregated data. Measurement ID:",
      "notConfigured": "not configured"
    },
    "cta": {
      "rejectNonEssential": "Reject non-essential",
      "save": "Save my preferences"
    },
    "savedAt": "Last updated:",
    "more": {
      "title": "Learn more",
      "text": "For more information about cookie usage and your rights, see our",
      "link": "informativa sulla privacy"
    },
    "toast": {
      "allAccepted": "All cookies have been accepted.",
      "onlyEssential": "Only essential cookies are kept.",
      "saved": "Your preferences have been saved."
    }
  },
  "pl": {
    "hero": {
      "title": "Ciasteczka i preferencje",
      "desc": "Używamy plików cookie, aby zapewnić prawidłowe działanie strony, mierzyć ruch i poprawiać Twoje doświadczenie. Możesz zmienić wybory w dowolnym momencie.",
      "badges": {
        "essential": "Niezbędne",
        "analytics": "Analityka",
        "performance": "Wydajność",
        "marketing": "Marketing"
      }
    },
    "summary": {
      "hint": "Zarządzaj zgodami według kategorii. Niezbędne ciasteczka są zawsze aktywne.",
      "reject": "Odrzuć wszystko (oprócz niezbędnych)",
      "accept": "Akceptuj wszystko"
    },
    "categories": {
      "essential": {
        "label": "Niezbędne (wymagane)",
        "desc": "Wymagane do działania strony (bezpieczeństwo, sesja, koszyk...). Nie można ich wyłączyć."
      },
      "analytics": {
        "label": "Pomiar oglądalności (Google Analytics)",
        "desc": "Pomaga zrozumieć korzystanie ze strony (odsłony, ścieżki). Dane zagregowane i anonimizowane."
      },
      "performance": {
        "label": "Wydajność",
        "desc": "Poprawia komfort przeglądania (cache, testy A/B, optymalizacja czasu ładowania)."
      },
      "marketing": {
        "label": "Marketing",
        "desc": "Personalizacja treści/reklam i śledzenie kampanii. Może pochodzić od partnerów."
      }
    },
    "state": {
      "on": "Włączone",
      "off": "Wyłączone"
    },
    "analytics": {
      "note": "Używane narzędzie: Google Analytics 4. IP zanonimizowane, dane zagregowane. ID pomiaru:",
      "notConfigured": "brak konfiguracji"
    },
    "cta": {
      "rejectNonEssential": "Odrzuć nieniezbędne",
      "save": "Zapisz preferencje"
    },
    "savedAt": "Ostatnia aktualizacja:",
    "more": {
      "title": "Dowiedz się więcej",
      "text": "Więcej informacji o plikach cookie i Twoich prawach znajdziesz w naszej",
      "link": "polityce prywatności"
    },
    "toast": {
      "allAccepted": "Wszystkie ciasteczka zostały zaakceptowane.",
      "onlyEssential": "Zachowano tylko niezbędne ciasteczka.",
      "saved": "Twoje preferencje zostały zapisane."
    }
  },
  "es": {
    "hero": {
      "title": "Cookies y preferencias",
      "desc": "Utilizamos cookies para garantizar el buen funcionamiento del sitio, medir la audiencia y mejorar tu experiencia. Puedes modificar tus elecciones en cualquier momento.",
      "badges": {
        "essential": "Esenciales",
        "analytics": "Analítica",
        "performance": "Rendimiento",
        "marketing": "Marketing"
      }
    },
    "summary": {
      "hint": "Gestiona tus consentimientos por categoría. Las cookies esenciales siempre están activas.",
      "reject": "Rechazar todo (excepto esenciales)",
      "accept": "Aceptar todo"
    },
    "categories": {
      "essential": {
        "label": "Esenciales (obligatorias)",
        "desc": "Necesarias para el funcionamiento del sitio (seguridad, sesión, carrito…). No pueden desactivarse."
      },
      "analytics": {
        "label": "Medición de audiencia (Google Analytics)",
        "desc": "Nos ayuda a entender el uso del sitio (páginas vistas, recorridos). Datos agregados y anonimizados."
      },
      "performance": {
        "label": "Rendimiento",
        "desc": "Mejora la experiencia de navegación (cache, pruebas A/B, optimización del tiempo de carga)."
      },
      "marketing": {
        "label": "Marketing",
        "desc": "Personalización de contenidos/anuncios y seguimiento de campañas. Puede provenir de socios externos."
      }
    },
    "state": {
      "on": "Activado",
      "off": "Desactivado"
    },
    "analytics": {
      "note": "Herramienta utilizada: Google Analytics 4. IP anonimizada, datos agregados. ID de medición:",
      "notConfigured": "no configurado"
    },
    "cta": {
      "rejectNonEssential": "Rechazar no esenciales",
      "save": "Guardar mis preferencias"
    },
    "savedAt": "Última actualización:",
    "more": {
      "title": "Más información",
      "text": "Para más información sobre el uso de cookies y tus derechos, consulta nuestra",
      "link": "política de privacidad"
    },
    "toast": {
      "allAccepted": "Se han aceptado todas las cookies.",
      "onlyEssential": "Solo se han conservado las cookies esenciales.",
      "saved": "Tus preferencias han sido guardadas."
    }
  },
  "it": {
    "hero": {
      "title": "Cookie e preferenze",
      "desc": "Utilizziamo i cookie per garantire che il sito funzioni correttamente, misurare il traffico e migliorare la tua esperienza. Puoi cambiare le tue scelte in qualsiasi momento.",
      "badges": {
        "essential": "Essenziale",
        "analytics": "Analisi",
        "performance": "Prestazioni",
        "marketing": "Marketing"
      }
    },
    "summary": {
      "hint": "Gestisci il tuo consenso per categoria. I cookie essenziali sono sempre attivi.",
      "reject": "Rifiutare tutto (eccetto essenziale)",
      "accept": "Accettate tutti"
    },
    "categories": {
      "essential": {
        "label": "Essenziale (richiesto)",
        "desc": "Richiesto per il funzionamento del sito (sicurezza, sessione, carrello...). Non puoi disattivarli."
      },
      "analytics": {
        "label": "Misura dell'audit (Google Analytics)",
        "desc": "Ci aiuta a capire l'utilizzo del sito (pagine, viaggi). Dati aggregati e anonimi."
      },
      "performance": {
        "label": "Prestazioni",
        "desc": "Migliora il comfort di navigazione (caching, test A/B, ottimizzazioni di tempo di carico)."
      },
      "marketing": {
        "label": "Marketing",
        "desc": "Contenuto/ad personalizzati e monitoraggio della campagna. Può venire dai soci."
      }
    },
    "state": {
      "on": "Su",
      "off": "Fuori"
    },
    "analytics": {
      "note": "Strumento utilizzato: Google Analytics 4. dati anonimi e aggregati IP. ID misura:",
      "notConfigured": "non configurato"
    },
    "cta": {
      "rejectNonEssential": "Rigetto non essenziale",
      "save": "Salva le mie preferenze"
    },
    "savedAt": "Ultimo aggiornamento:",
    "more": {
      "title": "Scopri di più",
      "text": "Per ulteriori informazioni sull'utilizzo dei cookie e sui tuoi diritti, vedere i nostri",
      "link": "privacy policy"
    },
    "toast": {
      "allAccepted": "Tutti i cookie sono stati accettati.",
      "onlyEssential": "Vengono conservati solo i cookie essenziali.",
      "saved": "Le tue preferenze sono state salvate."
    }
  },
  "de": {
    "hero": {
      "title": "Cookies & Präferenzen",
      "desc": "Wir verwenden Cookies, um sicherzustellen, dass die Website ordnungsgemäß funktioniert, den Traffic misst und Ihre Erfahrung verbessert. Sie können Ihre Auswahl jederzeit ändern.",
      "badges": {
        "essential": "Wichtig",
        "analytics": "Analytik",
        "performance": "Leistung",
        "marketing": "Marketing"
      }
    },
    "summary": {
      "hint": "Verwalten Sie Ihre Zustimmung nach Kategorie. Wichtige Cookies sind immer aktiv.",
      "reject": "Alle ablehnen (außer essentiell)",
      "accept": "Alle akzeptieren"
    },
    "categories": {
      "essential": {
        "label": "Wesentliches (erforderlich)",
        "desc": "Erforderlich für den Betrieb vor Ort (Sicherheit, Sitzung, Warenkorb ...). Sie können sie nicht deaktivieren."
      },
      "analytics": {
        "label": "Audience Measurement (Google Analytics)",
        "desc": "Hilft uns, die Nutzung der Website (Seitenansichten, Reisen) zu verstehen. Aggregierte und anonymisierte Daten."
      },
      "performance": {
        "label": "Leistung",
        "desc": "Verbessert den Browserkomfort (Caching, A/B-Tests, Ladezeitoptimierungen)."
      },
      "marketing": {
        "label": "Marketing",
        "desc": "Personalisierte Inhalte/Anzeigen und Kampagnen-Tracking. Kann von Partnern kommen."
      }
    },
    "state": {
      "on": "am",
      "off": "Ausgeschaltet"
    },
    "analytics": {
      "note": "Verwendetes Tool: Google Analytics 4. IP anonymisierte, aggregierte Daten. Kennung der Messung:",
      "notConfigured": "nicht konfiguriert"
    },
    "cta": {
      "rejectNonEssential": "Nicht-wesentlich ablehnen",
      "save": "Speichern Sie meine Präferenzen"
    },
    "savedAt": "Zuletzt aktualisiert:",
    "more": {
      "title": "Erfahren Sie mehr",
      "text": "Weitere Informationen über die Verwendung von Cookies und Ihre Rechte finden Sie in unserem",
      "link": "Datenschutzpolitik"
    },
    "toast": {
      "allAccepted": "Alle Cookies wurden akzeptiert.",
      "onlyEssential": "Es werden nur wesentliche Cookies gespeichert.",
      "saved": "Ihre Präferenzen wurden gespeichert."
    }
  },
  "pt": {
    "hero": {
      "title": "& Preferências de cookies",
      "desc": "Utilizamos cookies para garantir que o site funcione corretamente, medir o tráfego e melhorar a sua experiência. Você pode mudar suas escolhas a qualquer momento.",
      "badges": {
        "essential": "Essencial",
        "analytics": "Análise",
        "performance": "Desempenho",
        "marketing": "Comercialização"
      }
    },
    "summary": {
      "hint": "Gerencie seu consentimento por categoria. Os cookies essenciais estão sempre activos.",
      "reject": "Rejeitar tudo (exceto essencial)",
      "accept": "Aceitar tudo"
    },
    "categories": {
      "essential": {
        "label": "Essencial (obrigatório)",
        "desc": "Necessário para a operação do site (segurança, sessão, carrinho...). Você não pode desativá-los."
      },
      "analytics": {
        "label": "Medição de audiência (Google Analytics)",
        "desc": "Ajuda-nos a entender o uso do site (visitas de página, viagens). Dados agregados e anônimos."
      },
      "performance": {
        "label": "Desempenho",
        "desc": "Melhora o conforto de navegação (caching, testes A/B, otimizações de tempo de carga)."
      },
      "marketing": {
        "label": "Comercialização",
        "desc": "Conteúdo/Anúncios personalizados e acompanhamento de campanha. Pode vir de parceiros."
      }
    },
    "state": {
      "on": "Ligado",
      "off": "Desligado"
    },
    "analytics": {
      "note": "Ferramenta utilizada: Google Analytics 4. Dados anônimos e agregados IP. ID da medição:",
      "notConfigured": "não configurado"
    },
    "cta": {
      "rejectNonEssential": "Rejeitar não essencial",
      "save": "Salvar minhas preferências"
    },
    "savedAt": "Última actualização:",
    "more": {
      "title": "Saiba mais",
      "text": "Para mais informações sobre o uso de cookies e seus direitos, consulte",
      "link": "informativa sulla privacy"
    },
    "toast": {
      "allAccepted": "Todos os cookies foram aceitos.",
      "onlyEssential": "Apenas os cookies essenciais são mantidos.",
      "saved": "Suas preferências foram salvas."
    }
  },
  "cs": {
    "hero": {
      "title": "Cookies a preference",
      "desc": "Používáme cookies k zajištění řádného fungování webu, měření provozu a zlepšení vašich zkušeností. Můžete změnit své volby kdykoliv.",
      "badges": {
        "essential": "Základní",
        "analytics": "Analytika",
        "performance": "Výkonnost",
        "marketing": "Uvádění na trh"
      }
    },
    "summary": {
      "hint": "Spravujte svůj souhlas podle kategorií. Základní cookies jsou vždy aktivní.",
      "reject": "Zamítnout všechny (kromě nezbytných)",
      "accept": "Přijmout všechny"
    },
    "categories": {
      "essential": {
        "label": "Základní (povinné)",
        "desc": "Požadováno pro provoz na místě (bezpečnost, sezení, vozík...). Nemůžete je vyřadit."
      },
      "analytics": {
        "label": "Měření publika (Google Analytics)",
        "desc": "Pomáhá nám pochopit používání stránek (zobrazení stránek, cesty). Souhrnná a anonymizovaná data."
      },
      "performance": {
        "label": "Výkonnost",
        "desc": "Zlepšuje komfort při prohlížení (caching, A / B testy, optimalizace času načítání)."
      },
      "marketing": {
        "label": "Uvádění na trh",
        "desc": "Osobní obsah / reklamy a sledování kampaně. Možná od partnerů."
      }
    },
    "state": {
      "on": "Zapnout",
      "off": "Vypnout"
    },
    "analytics": {
      "note": "Použitý nástroj: Google Analytics 4. IP anonymní, agregovaná data. ID měření:",
      "notConfigured": "není nastaveno"
    },
    "cta": {
      "rejectNonEssential": "Zamítněte nepodstatné",
      "save": "Uložit své preference"
    },
    "savedAt": "Poslední aktualizace:",
    "more": {
      "title": "Přečtěte si více",
      "text": "Více informací o používání cookie a o vašich právech naleznete v našem",
      "link": "informativa sulla soukromí"
    },
    "toast": {
      "allAccepted": "Všechny sušenky byly přijaty.",
      "onlyEssential": "Drží se pouze základní cookies.",
      "saved": "Vaše preference byly zachráněny."
    }
  },
  "nl": {
    "hero": {
      "title": "Cookies & voorkeuren",
      "desc": "Wij gebruiken cookies om ervoor te zorgen dat de site goed werkt, het verkeer meet en uw ervaring verbetert. Je kunt je keuzes op elk moment veranderen.",
      "badges": {
        "essential": "Essentieel",
        "analytics": "Analyse",
        "performance": "Prestaties",
        "marketing": "Verkoop"
      }
    },
    "summary": {
      "hint": "Beheer uw toestemming per categorie. Essentiële cookies zijn altijd actief.",
      "reject": "Alles verwerpen (behalve essentieel)",
      "accept": "Alles accepteren"
    },
    "categories": {
      "essential": {
        "label": "Essentiële (noodzakelijk)",
        "desc": "Vereist voor site operatie (veiligheid, sessie, winkelwagen...). Je kunt ze niet uitschakelen."
      },
      "analytics": {
        "label": "Publieksmeting (Google Analytics)",
        "desc": "Helpt ons het gebruik van sites te begrijpen (paginaweergaven, reizen). Geaggregeerde en geanonimiseerde gegevens."
      },
      "performance": {
        "label": "Prestaties",
        "desc": "Verbetert het surfcomfort (caching, A/B testen, load-time optimalisaties)."
      },
      "marketing": {
        "label": "Verkoop",
        "desc": "Gepersonaliseerde inhoud/ads en campagne volgen. Kan van partners komen."
      }
    },
    "state": {
      "on": "Aan",
      "off": "Uit"
    },
    "analytics": {
      "note": "Gebruikt gereedschap: Google Analytics 4. IP geanonimiseerd, geaggregeerde gegevens. Meet-ID:",
      "notConfigured": "niet geconfigureerd"
    },
    "cta": {
      "rejectNonEssential": "Niet-essentiële afwijzing",
      "save": "Mijn voorkeuren opslaan"
    },
    "savedAt": "Laatst bijgewerkt:",
    "more": {
      "title": "Meer informatie",
      "text": "Voor meer informatie over cookiegebruik en uw rechten, zie onze",
      "link": "informativa sulla privacy"
    },
    "toast": {
      "allAccepted": "Alle cookies zijn geaccepteerd.",
      "onlyEssential": "Alleen essentiële cookies worden bewaard.",
      "saved": "Uw voorkeuren zijn opgeslagen."
    }
  }
};

export default cookieI18n;
